module.exports = __webpack_public_path__ + "media/newstyle/images/stars_3-orange-ba6bdb9044c51bc21a8430bb9aa140a1.svg";